import { Component, inject, signal } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValueChangeEvent, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { StripeAPIService } from '../../services/stripe-api.service';

import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

export interface CustomerCreditData {
  customer?: any,
  customerId?: string,
  customerName?: string,
  amount?: number,
  description?: string
}

@Component({
  selector: 'app-customer-credit-dialog',
  imports: [
    FormsModule, ReactiveFormsModule,
    MatInputModule, MatFormFieldModule, MatSnackBarModule, MatButtonModule
  ],
  templateUrl: './customer-credit-dialog.component.html',
  styleUrl: './customer-credit-dialog.component.css'
})
export class CustomerCreditDialogComponent {

  private _snackBar = inject(MatSnackBar);
  readonly dialogRef = inject(MatDialogRef<CustomerCreditDialogComponent>);
  readonly dialog = inject(MatDialog);
  readonly data = inject<CustomerCreditData>(MAT_DIALOG_DATA);
  stripeApi = inject(StripeAPIService);
  amountControl!: FormControl;
  descriptionControl!: FormControl;
  form!: any;
  payLoad: any;

  customerId: string = '';
  customerName: string = '';
  amount: number = 0;
  description: string = '';

  setForm() {
    //subNameControl = new FormControl('', Validators.required);
    this.amountControl = new FormControl(this.amount, Validators.required);
    this.descriptionControl = new FormControl(this.description, Validators.required);

    let formObj: any = {
      description: this.descriptionControl,
      amount: this.amountControl
    }

    this.form = signal(new FormGroup(formObj));
    this.payLoad = this.form().getRawValue();
  }

  async onSubmit() {
    console.log('onSubmit ', this.form().getRawValue());
    let creditBody = {
      amount: this.amountControl.value * 100, // convert from cents to dollars
      currency: 'usd',
      description: this.descriptionControl.value
    };
    let credit = await this.stripeApi.postCustomerCredit(creditBody, this.customerId);
    if (credit) {
      console.log('addCustomerCredit credit success', credit);
      this._snackBar.open('Successfully added a credit!', 'Dismiss');
      this.dialogRef.close();
    }
    else {
      console.log('error creating customer credit');
    }
  }

  ngOnInit() {
    console.log('CustomerCreditDialogComponent data', this.data);
    this.customerId = this.data.customerId || this.data.customer.stripe_id || '';
    this.customerName = this.data.customerName || this.data.customer.name || '';
    this.amount = this.data.amount || 0;
    this.description = this.data.description || '';
    this.setForm();
  }

}
